/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useRef } from "react";

import pdf from "../../../../icons/pdf.png";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import { header } from "../../../../components/api/Header";
import { monthName } from "../../../../components/functions/Month";
import LoadingCard from "../../../../components/loading/loadingCard";
import { ExcelPrint, Pdf } from "../../../../components/functions/Print";
import { getEnv } from "../../../../lib/env";
import { formatReservoirName } from "./helpers";

const TABLE_TITLE =
  "Respublika va respublikalararo suv omborlari ishlashi to'g'risida ma'lumot";

const normalizeReservoirSortName = (value) =>
  formatReservoirName(value)
    .toLowerCase()
    .replace(/[`'’‘ʻʼ]/g, "")
    .replace(/[^a-z0-9а-яёҳқғў]+/gi, "");

const isTuyamoyinReservoir = (row) =>
  normalizeReservoirSortName(row?.nomi).includes("tuyamoyin");

const isSmallReservoirsRow = (row) => {
  const name = normalizeReservoirSortName(row?.nomi);
  return (
    name.includes("kichiksuvombvaboshqalar") ||
    name.includes("kichiksuvomborlar")
  );
};

const isArnasoyReservoir = (row) =>
  normalizeReservoirSortName(row?.nomi).includes("arnasoy");

const shouldAddToRepublicTotal = (
  row,
  index,
  shuJumladanAfterIndex,
  firstTotalIndex
) =>
  index <= firstTotalIndex &&
  (index <= shuJumladanAfterIndex ||
    isArnasoyReservoir(row) ||
    isSmallReservoirsRow(row));

function getPreviousDate(value) {
  if (!value) return "";
  const [year, month, day] = value.split("-").map(Number);
  const current = new Date(year, month - 1, day);
  current.setDate(current.getDate() - 1);

  return [
    current.getFullYear(),
    String(current.getMonth() + 1).padStart(2, "0"),
    String(current.getDate()).padStart(2, "0"),
  ].join("-");
}

function getDateLabel(value) {
  if (!value) return "";
  return `${parseInt(value.slice(8, 10), 10)} ${monthName(value).toLowerCase()}`;
}

function Table3({ date, setOmbor, setLoading, loading }) {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const tuyamoyinIndex = data.findIndex(isTuyamoyinReservoir);
  const smallReservoirIndex = data.findIndex(isSmallReservoirsRow);
  const shuJumladanAfterIndex = tuyamoyinIndex >= 0 ? tuyamoyinIndex : 25;
  const firstTotalIndex = smallReservoirIndex >= 0 ? smallReservoirIndex : 30;
  const secondTotalIndex = smallReservoirIndex >= 0 ? smallReservoirIndex + 4 : 35;
  let searchTimeout;
  let sums1 = Array(12).fill(null);
  let sums2 = Array(12).fill(null);
  const selectedDateLabel = getDateLabel(date);
  const previousDateLabel = getDateLabel(getPreviousDate(date));

  const setSearch = (text) => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      $("tbody tr.data-tr").each(function () {
        if (
          $(this)
            .children(".fix-with")[0]
            .innerText.toUpperCase()
            .indexOf(text.toUpperCase()) > -1
        ) {
          $(this)[0].style.display = "";
        } else {
          $(this)[0].style.display = "none";
        }
      });
      if (text !== "") {
        $("tbody tr.j-tr").css("display", "none");
      } else {
        $("tbody tr.j-tr").css("display", "");
      }
    }, 500);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/suvombor/table3?date=" +
            date,
          header()
        );
        if (res) {
          setData(res.data);
        }
      } catch (e) {
        console.log("Xato", e);
        alert("Bazaga bog'lanishda xato");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [date]);

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => generatePDF()}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("so3", true, date)} className='btn p-0'>
              <img src={pdf} alt='404' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint("Hisob-kitob", "Sheet 1", "so3", date)
              }>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>
      {loading ? (
        <LoadingCard loading={loading} heightSize='80vh' />
      ) : (
        <div className='table-responsive tableFixHead' id='tableFlexible'>
          <div ref={conponentPDF} style={{ width: "100%" }}>
            <table
              className='table table-bordered table-style suv-reservoir-table'
              id='so3'>
              <thead>
                <tr>
                  <th colSpan={14} scope='col'>
                    {TABLE_TITLE}
                  </th>
                </tr>

                <tr>
                  <th rowSpan={3} scope='col'>
                    N
                  </th>

                  <th rowSpan={3} scope='col'>
                    Suv omborlar nomi
                  </th>

                  <th colSpan={4} scope='col'>
                    Hajmi (mln.m3)
                  </th>

                  <th colSpan={3} scope='col'>
                    Kelishi, m3/sek
                  </th>

                  <th colSpan={3} scope='col'>
                    Chiqishi, m3/sek
                  </th>

                  <th rowSpan={2} scope='col'>
                    Kelishi-Chiqishi
                  </th>

                  <th rowSpan={2} scope='col'>
                    Yo'qolishi
                  </th>
                </tr>

                <tr>
                  <th rowSpan={2} scope='col'>
                    Loyiha bo’yicha
                  </th>

                  <th colSpan={2} scope='col'>
                    Amalda
                  </th>

                  <th rowSpan={2} scope='col'>
                    Farqi +-
                  </th>

                  <th colSpan={2} scope='col'>
                    Amalda
                  </th>

                  <th rowSpan={2} scope='col'>
                    Farqi +-
                  </th>

                  <th colSpan={2} scope='col'>
                    Amalda
                  </th>

                  <th rowSpan={2} scope='col'>
                    Farqi +-
                  </th>
                </tr>

                <tr>
                  <th scope='col'>{previousDateLabel}</th>

                  <th scope='col'>{selectedDateLabel}</th>

                  <th scope='col'>{previousDateLabel}</th>

                  <th scope='col'>{selectedDateLabel}</th>

                  <th scope='col'>{previousDateLabel}</th>

                  <th scope='col'>{selectedDateLabel}</th>

                  <th colSpan={2} scope='col'>
                    mln.m<sup>3</sup>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr className='table-one-row'>
                  <td colSpan={14}>Respublika</td>
                </tr>
              </tbody>

              {data.length > 0
                ? data.map((d, index) => {
                    if (index === 0) {
                      sums1 = Array(12).fill(null);
                      sums2 = Array(12).fill(null);
                    }

                    if (
                      shouldAddToRepublicTotal(
                        d,
                        index,
                        shuJumladanAfterIndex,
                        firstTotalIndex
                      )
                    ) {
                      sums1[0] = qosh(sums1[0], d.loyiha_boyicha);

                      sums1[1] = qosh(sums1[1], d.data1);

                      sums1[2] = qosh(sums1[2], d.data2);

                      sums1[3] = qosh(
                        sums1[3],
                        nullableFarq(d.data2, d.data1)
                      );

                      sums1[4] = qosh(sums1[4], d.data3);

                      sums1[5] = qosh(sums1[5], d.data4);

                      sums1[6] = qosh(
                        sums1[6],
                        nullableFarq(d.data4, d.data3)
                      );

                      sums1[7] = qosh(sums1[7], d.data5);

                      sums1[8] = qosh(sums1[8], d.data6);

                      sums1[9] = qosh(
                        sums1[9],
                        nullableFarq(d.data6, d.data5)
                      );

                      sums1[10] = qosh(
                        sums1[10],
                        nullableFarq(d.data4, d.data6, true)
                      );

                      sums1[11] = qosh(
                        sums1[11],
                        nullableDifferenceOfDifferences(
                          d.data2,
                          d.data1,
                          d.data4,
                          d.data6
                        )
                      );
                    }

                    if (index > firstTotalIndex) {
                      sums2[0] = qosh(sums2[0], d.loyiha_boyicha);

                      sums2[1] = qosh(sums2[1], d.data1);

                      sums2[2] = qosh(sums2[2], d.data2);

                      sums2[3] = qosh(
                        sums2[3],
                        nullableFarq(d.data2, d.data1)
                      );

                      sums2[4] = qosh(sums2[4], d.data3);

                      sums2[5] = qosh(sums2[5], d.data4);

                      sums2[6] = qosh(
                        sums2[6],
                        nullableFarq(d.data4, d.data3)
                      );

                      sums2[7] = qosh(sums2[7], d.data5);

                      sums2[8] = qosh(sums2[8], d.data6);

                      sums2[9] = qosh(
                        sums2[9],
                        nullableFarq(d.data6, d.data5)
                      );

                      sums2[10] = qosh(
                        sums2[10],
                        nullableFarq(d.data4, d.data6, true)
                      );

                      sums2[11] = qosh(
                        sums2[11],
                        nullableDifferenceOfDifferences(
                          d.data2,
                          d.data1,
                          d.data4,
                          d.data6
                        )
                      );
                    }

                    return (
                      <tbody key={index}>
                        <tr className='data-tr'>
                          <td>{index + 1}</td>

                          <td className='text-start fix-with'>
                            <NavLink
                              style={{
                                color: "#222",
                              }}
                              to={"/suvomborlari/" + d.id}
                              onClick={() =>
                                setOmbor({
                                  nomi: d.nomi,
                                  location: [d.lat, d.lan],
                                })
                              }>
                              {formatReservoirName(d.nomi)}
                            </NavLink>
                          </td>

                          <td>{filteredValue(d.loyiha_boyicha)}</td>

                          <td>{filteredValue(d.data1)}</td>

                          <td>{filteredValue(d.data2)}</td>

                          <td>{filteredFarq(d.data2, d.data1)}</td>

                          <td>{filteredValue(d.data3)}</td>

                          <td>{filteredValue(d.data4)}</td>

                          <td>{filteredFarq(d.data4, d.data3)}</td>

                          <td>{filteredValue(d.data5)}</td>

                          <td>{filteredValue(d.data6)}</td>

                          <td>{filteredFarq(d.data6, d.data5)}</td>

                          <td>{filteredFarq(d.data4, d.data6, true)}</td>

                          <td>
                            {filteredDifferenceOfDifferences(
                              d.data2,
                              d.data1,
                              d.data4,
                              d.data6
                            )}
                          </td>
                        </tr>

                        {index === shuJumladanAfterIndex ? (
                          <tr className='j-tr'>
                            <td></td>
                            <td>shu jumladan</td>
                            {Array.from({ length: 12 }).map((_, cellIndex) => (
                              <td key={cellIndex}></td>
                            ))}
                          </tr>
                        ) : null}

                        {index === firstTotalIndex ? (
                          <>
                            <tr className='j-tr'>
                              <td colSpan={2}>Jami</td>

                              {sums1.map((s, i) => {
                                return <td key={i}>{filteredValue(s)}</td>;
                              })}
                            </tr>
                            <tr className='table-one-row j-tr'>
                              <td colSpan={14}>Respublikalararo</td>
                            </tr>
                          </>
                        ) : null}

                        {index === secondTotalIndex ? (
                          <>
                            <tr className='j-tr'>
                              <td colSpan={2}>Jami</td>

                              {sums2.map((s, i) => {
                                return <td key={i}>{filteredValue(s)}</td>;
                              })}
                            </tr>

                            <tr className='j-tr'>
                              <td colSpan={2}>Hammasi</td>

                              {mergeSums(sums1, sums2).map((s, i) => {
                                return <td key={i}>{filteredValue(s)}</td>;
                              })}
                            </tr>
                          </>
                        ) : null}
                      </tbody>
                    );
                  })
                : null}
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default Table3;

const check = (v) => {
  if (v === undefined || v === null || v === "undefined" || v === "") return 0;

  const n = parseFloat(v);
  if (isNaN(n)) return 0;

  return n;
};

const hasNumericValue = (v) => {
  if (v === undefined || v === null || v === "undefined" || v === "") {
    return false;
  }

  return !isNaN(parseFloat(v));
};

const farq = (a = 0, b = 0, kop = false) => {
  let s = check(a) - check(b);

  if (kop) {
    s = s * 0.0864;
  }

  return s % 1 !== 0 ? parseFloat(s.toFixed(2)) : s;
};

const filteredFarq = (a, b, kop = false) => {
  if (!hasNumericValue(a) || !hasNumericValue(b)) return "-";

  return farq(a, b, kop);
};

const nullableFarq = (a, b, kop = false) => {
  if (!hasNumericValue(a) || !hasNumericValue(b)) return null;

  return farq(a, b, kop);
};

const filteredDifferenceOfDifferences = (data2, data1, data4, data6) => {
  if (
    !hasNumericValue(data2) ||
    !hasNumericValue(data1) ||
    !hasNumericValue(data4) ||
    !hasNumericValue(data6)
  ) {
    return "-";
  }

  return farq(farq(data2, data1), farq(data4, data6, true));
};

const nullableDifferenceOfDifferences = (data2, data1, data4, data6) => {
  if (
    !hasNumericValue(data2) ||
    !hasNumericValue(data1) ||
    !hasNumericValue(data4) ||
    !hasNumericValue(data6)
  ) {
    return null;
  }

  return farq(farq(data2, data1), farq(data4, data6, true));
};

const qosh = (a, b) => {
  if (!hasNumericValue(b)) {
    return hasNumericValue(a) ? a : null;
  }

  const base = hasNumericValue(a) ? parseFloat(a) : 0;
  const s = base + parseFloat(b);

  if (isNaN(s)) return;

  return s;
};

const mergeSums = (first, second) =>
  first.map((value, index) => qosh(value, second[index]));

const filteredValue = (a) => {
  if (a === null || a === undefined || a === "" || a === "undefined") {
    return "-";
  }

  const n = parseFloat(a);
  if (isNaN(n)) return "-";

  const rounded = Math.round((n + Number.EPSILON) * 10) / 10;

  return rounded % 1 === 0 ? Math.floor(rounded) : rounded;
};
